import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import ProgressOnTable from './ProgressOnTable';
import NumberUtils from '../../utils/NumberUtils';

class BudgetTableRowTemplateMobile extends Component {
  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    this.props.customClick(this.props.rowData.name, this.props.rowData);
  }

  render() {
    const { content, rowData } = this.props;
    const budgetValue = rowData.target_amount;
    const currentMonth = rowData.current_month;
    let colData;
    let colDataNullCheck;
    let message;
    let difference;
    let isArchived;

    if (rowData.archived || rowData.joint) {
      isArchived = 'column-fade';
    }

    if (Number(currentMonth) === 0 && Number(budgetValue) === 0) {
      message = 'No budget set';
    } else {
      if (Number(currentMonth) < Number(budgetValue)) {
        message = 'Underspent';
      } else if (Number(currentMonth) > Number(budgetValue)) {
        message = 'Overspent';
      } else {
        message = 'Nothing left to spend';
      }
    }
    if (_.isNull(rowData.difference)) {
      difference = Number(budgetValue) + Number(currentMonth);
      colDataNullCheck = (
        <h5>{NumberUtils.appendCurrency('{}', difference)}</h5>
      );
    } else if (!_.isNumber(rowData.difference)) {
      difference = Number(0);
      message = 'Nothing left to spend';
      colDataNullCheck = <h5>£0</h5>;
    } else {
      colDataNullCheck = (
        <h5>{NumberUtils.appendCurrency('{}', rowData.difference)}</h5>
      );
    }
    colData = (
      <div onClick={this.onClick}>
        <label className={`${isArchived}`}>
          <span className="icon icon-tag" />
          {rowData.name}
        </label>
        <section className="progress-section">
          <ProgressOnTable {...this.props} />
        </section>
        <section>
          <p>{content.spendingTableHeaderText2}</p>
          <p>{content.spendingTableHeaderText3}</p>
          <p>{message}</p>
        </section>
        <section>
          <h5>{NumberUtils.appendCurrency('{}', currentMonth)}</h5>
          <h5>{NumberUtils.appendCurrency('{}', budgetValue)}</h5>
          {colDataNullCheck}
        </section>
      </div>
    );
    return <div className="transaction-row">{colData}</div>;
  }
}

BudgetTableRowTemplateMobile.propTypes = {
  rowData: PropTypes.object,
  customClick: PropTypes.func,
  content: PropTypes.object,
};

export { BudgetTableRowTemplateMobile };
